/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 06 2023
 **/

import { PropsWithChildren, Children, cloneElement } from "react";
import { Properties } from "../../properties";
import useCheckVersion from "./useCheckVersion";

export function Allow(
	props: PropsWithChildren<{
		solution: string | string[];
		test?: boolean;
		withSaaS?: boolean;
	}>
) {
	return <>{props.children}</>;
}

export function Disallow(
	props: PropsWithChildren<{
		solution: string | string[];
		test?: boolean;
		withSaaS?: boolean;
	}>
) {
	return <>{props.children}</>;
}

export function SaaS(props: PropsWithChildren<unknown>) {
	return <>{props.children}</>;
}

export default function CheckVersion(props: PropsWithChildren<CheckVersionOptions>) {
	if (!("allows" in props === false && "disallows" in props === false)) {
		const version = useCheckVersion(props);
		if (props.showDebug) {
			props.showDebug && console.debug("CheckVersion ====>", version, props);
		}
		return version.allowed ? <>{props.children}</> : version.callback ? <>{version.callback()}</> : null;
	} else {
		if (Properties.solution.length > 0) {
			const childrens = Children.map(props.children, (children, index) => {
				if (children) {
					// @ts-ignore
					if (children.type.name === Allow.name) {
						if (
							// @ts-ignore
							(typeof children.props.solution === "string" &&
								// @ts-ignore
								children.props.solution === Properties.solution) ||
							// @ts-ignore
							(Array.isArray(children.props.solution) &&
								// @ts-ignore
								children.props.solution.includes(Properties.solution))
						) {
							const isRendering =
								// @ts-ignore
								"test" in children.props &&
								// @ts-ignore
								children.props.test
									? true
									: // @ts-ignore
										"test" in children.props
										? false
										: true;
							if (isRendering) {
								const key =
									// @ts-ignore
									"key" in children.props
										? // @ts-ignore
											children.props.key
										: `${index}`;
								/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
								return cloneElement(children as any, {
									key
								});
							} else {
								return null;
							}
						}
					}

					// @ts-ignore
					if (children.type.name === Disallow.name) {
						if (
							// @ts-ignore
							(typeof children.props.solution === "string" &&
								// @ts-ignore
								children.props.solution !== Properties.solution) ||
							// @ts-ignore
							(Array.isArray(children.props.solution) &&
								// @ts-ignore
								!children.props.solution.includes(Properties.solution))
						) {
							const isRendering =
								// @ts-ignore
								"test" in children.props &&
								// @ts-ignore
								children.props.test
									? true
									: // @ts-ignore
										"test" in children.props
										? false
										: true;
							if (isRendering) {
								// @ts-ignore
								const key =
									// @ts-ignore
									"key" in children.props
										? // @ts-ignore
											children.props.key
										: `${index}`;
								/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
								return cloneElement(children as any, {
									key
								});
							} else {
								return null;
							}
						}
					}
				}
				return null;
			});
			return <>{childrens?.filter(Boolean)}</>;
		} else {
			const childrens = Children.map(props.children, (children, index) => {
				// @ts-ignore
				if (children && children.type.name === SaaS.name) {
					// @ts-ignore
					const key =
						// @ts-ignore
						"key" in children.props
							? // @ts-ignore
								children.props.key
							: `${index}`;
					/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
					return cloneElement(children as any, { key });
				}

				// @ts-ignore
				if (children && children.type.name === Allow.name) {
					if (
						// @ts-ignore
						"withSaaS" in children.props &&
						// @ts-ignore
						children.props.withSaaS
					) {
						// @ts-ignore
						const key =
							// @ts-ignore
							"key" in children.props
								? // @ts-ignore
									children.props.key
								: `${index}`;
						return cloneElement(children as any, {
							key
						});
					}
				}

				return null;
			});
			return <>{childrens?.filter(Boolean)}</>;
		}
	}
}
